import React, { Fragment } from 'react'
import { Card, Col, Label, FormGroup, Row } from 'reactstrap';
import Datetime from 'react-datetime';
import { useInformedConsent } from '../../hooks/InformedConsent/useInformedConsent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';


export const IndexInformedConsent = () => {

    const {
        date_ini, date_end,
        handleChangeValue,
        handleFilter,
        listInformedConsent,
        printPdfConsentInformed,
        nextPage, previousPage, totalPageCount, currentPage, goToPage,
        loadingPreviewId, pdfPreviewUrl, showPreview, handleOpenPreview, setShowPreview, loadingDownloadId

    } = useInformedConsent();


    const divStyle = {
        backgroundColor: "#46afe5",
        borderColor: "#46afe5",
        color: "#fff",
        textAlign: "center",
        cursor: "pointer",
        padding: "8px 16px",
    };



    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };


    return (
        <Fragment>
            <div className='container-global-zoom p-3'>
                <Card>
                    <Col sm="12" className="pt-3">
                        <FormGroup>
                            <Row className="g-3 align-items-center justify-content-start text-left">
                                {/* Título Filtros */}
                                <Col xs="auto" md="auto" className="mb-2">
                                    <h5 className="f-16 f-w-700 text-info mb-0">Filtros de búsqueda</h5>
                                </Col>
                                {/* Fecha inicio */}
                                <Col xs="12" md="2" className="d-flex flex-column align-items-start mb-2 pl-0">
                                    <Label className="f-w-600 f-12 badge badge-light-primary mb-1">Fecha de inicio</Label>
                                    <Datetime
                                        inputProps={
                                            {
                                                placeholder: 'DD-MM-YYYY',
                                                name: 'date_ini',
                                                autoComplete: "nope",
                                                className: 'form-control digits input-air-primary form-control-sm'
                                            }
                                        }
                                        timeFormat={false}
                                        dateFormat={"DD-MM-YYYY"}
                                        locale="es"
                                        value={date_ini}
                                        onChange={(e) => handleChangeValue(e, 'date_ini')}
                                        closeOnSelect={true}
                                        nextPage={nextPage}
                                        previousPage={previousPage}
                                        totalPageCount={totalPageCount}
                                        currentPage={currentPage}
                                        goToPage={goToPage}
                                    />
                                </Col>
                                {/* Fecha final */}
                                <Col xs="12" md="2" className="d-flex flex-column align-items-start mb-2 pl-0">
                                    <Label className="f-w-600 f-12 badge badge-light-primary mb-1">Fecha final</Label>
                                    <Datetime
                                        inputProps={
                                            {
                                                placeholder: 'DD-MM-YYYY',
                                                name: 'date_end',
                                                autoComplete: "nope",
                                                className: 'form-control digits input-air-primary form-control-sm'
                                            }
                                        }
                                        timeFormat={false}
                                        dateFormat={"DD-MM-YYYY"}
                                        locale="es"
                                        value={date_end}
                                        onChange={(e) => handleChangeValue(e, 'date_end')}
                                        closeOnSelect={true}
                                    />
                                </Col>

                                {/* Botón buscar */}
                                <Col xs="12" md="2" className="d-flex flex-column align-items-start mt-3 pl-0">

                                    <div
                                        onClick={handleFilter}
                                        className="pointer w-100 text-left py-1"
                                        style={{ ...divStyle, maxWidth: "80px" }}
                                    >
                                        Buscar
                                    </div>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>

                    <Col sm="12" className='pt-2' >
                        <div className="table-responsive">
                            <DataTable
                                value={listInformedConsent}
                                paginator
                                rows={10}
                                className="data-table p-datatable-striped p-datatable-sm"
                                emptyMessage={
                                    <div className="text-center">
                                        <img src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                        <br />
                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>Sin cotizaciones.</p>
                                    </div>
                                }
                                rowsPerPageOptions={[10, 50, 100]}
                                responsiveLayout="scroll"
                            >
                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                <Column field="nim" header="Nim" headerStyle={headerStyle} style={cellStyle} />
                                <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle} />
                                <Column field="surnames" header="Apellidos" sortable headerStyle={headerStyle} style={cellStyle} />
                                <Column field="date" header="Fecha" headerStyle={headerStyle} style={cellStyle} />

                                <Column
                                    header="Acciones"
                                    headerStyle={headerStyle}
                                    style={{ ...cellStyle, textAlign: "center" }}
                                    body={(rowData) => (
                                        <div className="d-flex justify-content-center gap-2">
                                            <button
                                                onClick={() => printPdfConsentInformed(rowData.nim)}
                                                title="Descargar"
                                                disabled={loadingDownloadId === rowData.nim}
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    fontSize: "0.65rem",
                                                    borderRadius: "8px",
                                                    padding: "0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                className="btn btn-danger mr-1"
                                            >
                                                {loadingDownloadId === rowData.nim ? (
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                ) : (
                                                    <i className="fa fa-file-pdf-o"></i>


                                                )}
                                            </button>
                                            <button
                                                onClick={() => handleOpenPreview(rowData.nim)}
                                                title="Previsualizar Cotización"
                                                disabled={loadingPreviewId === rowData.nim}
                                                style={{
                                                    width: "30px",
                                                    height: "30px",
                                                    fontSize: "0.65rem",
                                                    borderRadius: "8px",
                                                    padding: "0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center"
                                                }}
                                                className="btn btn-primary"
                                            >
                                                {loadingPreviewId === rowData.nim ? (
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                ) : (
                                                    <i className="icofont icofont-ui-search"></i>
                                                )}
                                            </button>
                                        </div>
                                    )}
                                />
                            </DataTable>
                        </div>
                    </Col>
                </Card>
                <Dialog
                    header="Previsualización de PDF"
                    visible={showPreview}
                    style={{ width: '60vw', maxWidth: '700px' }}
                    modal
                    dismissableMask
                    onHide={() => setShowPreview(false)}
                    headerStyle={{
                        backgroundColor: '#0d3b59',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                    pt={{
                        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                        headerIcon: { style: { color: 'white' } },
                    }}
                >
                    {pdfPreviewUrl && (
                        <iframe
                            src={pdfPreviewUrl}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    )}
                </Dialog>
            </div>
        </Fragment>
    )
}
